module.exports = __webpack_public_path__ + "img/data.92d882fe.svg";